import React from 'react';
import { X } from 'lucide-react';
import { Link, usePage } from '@inertiajs/react';
import { AffiliateLayout } from '../../../design-system/components/layouts';
import { Button } from '../../../design-system/components';
import { root_path, affiliate_new_application_path } from '../../../lib/routes';
export default function Denied() {
  const { props } = usePage();
  const appName = props.app_name ?? 'Speakflow';
  const supportEmail = props.app_config?.support_email;
  const denialReason = props.denial_reason;
  const canReapply = props.can_reapply;
  return (
    <AffiliateLayout>
      <div className="max-w-lg mx-auto py-16 px-4 sm:px-6 text-center">
        {/* X icon */}
        <div className="mx-auto w-16 h-16 rounded-full bg-danger-50 flex items-center justify-center mb-6">
          <X size={32} className="text-danger-500" />
        </div>

        <h1 className="text-2xl font-semibold text-fg tracking-tight">
          Application Not Approved
        </h1>

        <p className="mt-4 text-fg-tertiary leading-relaxed">
          Unfortunately, your application to the {appName} Affiliate Program was not approved at
          this time.
        </p>

        {/* Denial reason */}
        {denialReason && (
          <div className="mt-6 bg-surface-secondary rounded-xl p-5 text-left">
            <h2 className="text-sm font-semibold text-fg mb-2">Reason</h2>
            <p className="text-sm text-fg-secondary leading-relaxed">{denialReason}</p>
          </div>
        )}

        {/* Actions */}
        <div className="mt-8 space-y-3">
          {canReapply && (
            <Link href={affiliate_new_application_path()}>
              <Button variant="primary" className="w-full">
                Reapply
              </Button>
            </Link>
          )}
          <Link href={root_path()}>
            <Button variant={canReapply ? 'secondary' : 'primary'} className="w-full">
              Back to Home
            </Button>
          </Link>
          {supportEmail && (
            <p className="text-xs text-fg-tertiary">
              Have questions?{' '}
              <a
                href={`mailto:${supportEmail}`}
                className="text-fg hover:text-fg-secondary"
              >
                Contact support
              </a>
            </p>
          )}
        </div>
      </div>
    </AffiliateLayout>
  );
}
